import { render } from "./Blogs.vue?vue&type=template&id=68fce7a2"
import script from "./Blogs.vue?vue&type=script&lang=js"
export * from "./Blogs.vue?vue&type=script&lang=js"
script.render = render

export default script